import React, { useEffect } from "react";

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// style
import "../../../assets/css/loading.css";

// helpers
import {formateDate} from "../../../helpers/formats.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import { getSessionCookie} from "../../../services/session.js";

// views
import VeiculosForm from '../../../views/admin/cadastros/VeiculosForm.jsx';

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function VeiculosList({history}) {
  const session = getSessionCookie();

  const [showLoading, setshowLoading] = React.useState(false);
  
  const [list_table, set_list_table] = React.useState([])
  const[list_loading, set_list_loading] = React.useState(false);
  
  const[showDetail, setshowDetail] = React.useState(false);
  const[itemDetail, setitemDetail] = React.useState(null);
  
  const GetList = () => {    
    set_list_loading(true);

    let endpoint = "veiculo";
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

    api_GET(endpoint).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        let list = [];
        result.data.map(m => {
          let item = m;
          item.listamodalidades = handleExibeModalidades(m);
          item.validadeVistoriaFormat = formateDate(m.validadeVistoria);
          list.push(item);
        })
        set_list_table(list);
      }
    });
  }

  const Edit = (event, rowData) => {    
    setshowLoading(true);
    api_GET(`veiculo/${rowData.veiculoId}`).then(result => {
      setshowLoading(false);      
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        setshowDetail(true);    
        setitemDetail(result.data);
      }
    });    
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);    
  };

  const handleReturn = (item) => {
    if (item != null)
    {
        GetList();
    }
    setshowDetail(false);  
    setitemDetail(null);  
  }

  useEffect(() => {
    GetList();
  }, []);

  const handleExibeModalidades = (rowData) => {
    let modalidades = "";
    
    for(var i in rowData.veiculoModalidadeColeta){
      if (modalidades != "") modalidades += " | ";
      modalidades += rowData.veiculoModalidadeColeta[i].modalidadeColeta.descricao;
    }

    return modalidades
  }

  const columnsProp = [
    { title: 'Concessionária', field: 'concessionaria.identificacao' },
    { title: 'Placa/Identificação', field: 'placa' },
    { title: 'Modalidades', field: 'listamodalidades'},
    { title: 'Equipamento', field: 'tipoImplemento' },      
    { title: 'Validade Vistoria', field: 'validadeVistoriaFormat' },
    { title: 'Status', field: 'status' }     
  ]  

  return (
    <>
    {showLoading && 
          <div className="carregandoCmp">
              <div className="box">
                <label style={{marginRight:"20px"}}>Carregando...</label>
                <Spinner size="sm" color="info" />
              </div>
          </div> 
        } 
        <Header />
        <Container className="mt--9" fluid>

          {!showDetail &&
            <Row>
              <Container className="mt-1" fluid>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                        <Col md="6">
                          <strong> Recursos</strong>
                        </Col>
                        <Col md="6" className="text-right">                              
                          <Button color="primary" type="submit" onClick={() => Add()}>
                            <FontAwesomeIcon icon={faPlus} />  Novo Recurso
                          </Button>
                        </Col>
                      </Row>                          
                  </CardHeader>  
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <MaterialTable
                            title="Lista de Recursos"
                            columns={columnsProp}
                            data={list_table}
                            isLoading={list_loading}
                            options={{
                              ...table_style,
                              pageSize: 20,
                              pageSizeOptions : [20, 50, list_table.length]
                            }}
                            actions={[
                              {
                                icon: 'edit',
                                tooltip: 'Editar Registro',
                                onClick: (event, rowData) => Edit(event, rowData)
                              }
                            ]}
                            localization={table_translate}  
                          />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>                  
              </Container>
            </Row>
          }          
          
          {showDetail && 
            <VeiculosForm handleReturn={handleReturn} item={itemDetail}></VeiculosForm>
          }

        </Container>        

    </>
  );
}
